import { css } from "@emotion/core";

export const registrationFooterButton = css`
  .mobile-btn-height {
    height: 3.13em;
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-constant-footer-container {
      bottom: 0em;
      z-index: 4;
      padding: 1em 0.5em;
      width: 100%;
    }
  }
`;
